import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ShieldIcon, ArrowLeftIcon } from 'lucide-react';
import { PrivacyAccordion } from '../components/policies/PrivacyAccordion';
export function Privacy() {
  return <>
      <Helmet data-id="element-1849">
        <title data-id="element-1850">Privacy & Cookie Policy | Bright Pixxel Studios</title>
        <meta name="description" content="Our Privacy & Cookie Policy explains how we collect, use and protect your personal data in compliance with GDPR regulations." data-id="element-1851" />
      </Helmet>
      {/* Hero Section */}
      <section className="pt-16 md:pt-24 pb-12 bg-[#F9FAFB] dark:bg-[#121212]" data-id="element-1852">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1853">
          <div className="max-w-4xl mx-auto" data-id="element-1854">
            <Link to="/policies" className="inline-flex items-center text-[#0C1B26] hover:underline mb-6" data-id="element-1855">
              <ArrowLeftIcon size={16} className="mr-1" data-id="element-1856" />
              Back to Policies
            </Link>
            <div className="flex items-center mb-6" data-id="element-1857">
              <div className="w-12 h-12 rounded-full bg-[#0C1B26]/10 dark:bg-[#0C1B26]/20 flex items-center justify-center mr-4" data-id="element-1858">
                <ShieldIcon size={24} className="text-[#0C1B26]" data-id="element-1859" />
              </div>
              <motion.h1 initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.5
            }} className="text-3xl md:text-4xl font-bold" data-id="element-1860">
                Privacy & Cookie Policy
              </motion.h1>
            </div>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-lg text-gray-600 dark:text-gray-300 mb-4" data-id="element-1861">
              Last Updated: May 1, 2023
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg text-gray-600 dark:text-gray-300" data-id="element-1862">
              This Privacy & Cookie Policy explains how Bright Pixxel Studios
              ("we", "us", "our") collects, uses, and protects your personal
              information when you use our website and services. We are
              committed to ensuring the privacy and security of your data in
              compliance with the General Data Protection Regulation (GDPR).
            </motion.p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-12 bg-white dark:bg-[#1E1E1E]" data-id="element-1863">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1864">
          <div className="max-w-4xl mx-auto" data-id="element-1865">
            <PrivacyAccordion data-id="element-1866" />
          </div>
        </div>
      </section>
    </>;
}